import { storage } from "./../utils/authToken"
import moment from "moment";
/** -------------------------
 * CONSTANT KEYS
 * ------------------------ */
export const ACCESS_TOKEN_KEY = "_business_panel_token";
export const ACCESS_USER_ID = "_id";
export const ACCESS_USER_TYPE = "_type";
export const ACCESS_PASSWORD_RESET = "is_password_reset";

export const CONTENT_TYPE = { "Content-Type": "application/json" };
export const CONTENT_TYPE_LOGIN = {
    Authorization: `Basic ZGV2Z2xhbi1jbGllbnQ6V2ViQ2xpZW50QDA5MDEyMDE5`,
    "Content-Type": "application/x-www-form-urlencoded",
};

// Base root path
export const rootPath = `/storelocator/business`;


/** -------------------------
 * LOGIN REDIRECTION LOGIC
 * ------------------------ */
const redirectPaths = {
    store: `${rootPath}/dashboard/rj`,
    leadgeneration: `${rootPath}/leadgeneration-list`,
    nach: `${rootPath}/nach-list`,
    jewels: `${rootPath}/maketoorder-list-jewels`,
    jewelshub: `${rootPath}/prebook-list`,
    "manage-qr-code": `${rootPath}/manage-bar-code`,
};

const orderRedirect = (u) =>
    `${rootPath}/${u?.is_password_reset ? "search-order" : `reset-password/${u?._id}`
    }`;

export const redirectAfterLogin = (data) => {
    const u = data?.user;
    if (!u) return;

    if (u.type === "order") {
        window.location = orderRedirect(u);
    } else {
        window.location = redirectPaths[u.type] ?? `${rootPath}/dashboard/rj`;
    }
};

/** -------------------------
 * LOGOUT
 * ------------------------ */
export const logout = () => {
    const userType = storage.getUserType();
    storage.clearAll();
    if (userType === "order") {
        window.location = `${rootPath}/roma-login`;
    } else {
        window.location = `${rootPath}/login`;
    }
};

/** -------------------------
 * CHECK LOGIN STATUS
 * ------------------------ */
export const isLogin = () => !!localStorage.getItem(ACCESS_TOKEN_KEY);

/** -------------------------
 * ROUTE PERMISSIONS (CLEANER)
 * ------------------------ */
export const manageRoutes = {
    store: [
        `${rootPath}/dashboard`,
        `${rootPath}/store-list`,
        `${rootPath}/add-store`,
        `${rootPath}/edit-store`,
        `${rootPath}/store-master-list`,
        `${rootPath}/edit-store-master`,
        `${rootPath}/add-store-master`,
    ],

    jewels: [`${rootPath}/maketoorder-list-jewels`],

    "manage-qr-code": [
        `${rootPath}/manage-bar-code`,
        `${rootPath}/scan-bar-code`,
        `${rootPath}/upload-bar-code`,
    ],

    jewelshub: [
        `${rootPath}/prebook-list`,
        `${rootPath}/enquiry-list`,
        `${rootPath}/edit-prebook`,
        `${rootPath}/like-product-list`,
        `${rootPath}/maketoorder-list`,
        `${rootPath}/event-campaign-list`,
        `${rootPath}/nso-campaign-list`,
        `${rootPath}/wishlist`,
        `${rootPath}/feedbacklist`,
    ],

    leadgeneration: [
        `${rootPath}/leadgeneration-list`,
        `${rootPath}/rannkaar-list`,
        `${rootPath}/prebook-list`,
        `${rootPath}/enquiry-list`,
        `${rootPath}/edit-prebook`,
        `${rootPath}/callback-list`,
        `${rootPath}/appointment-list`,
        `${rootPath}/event-campaign-list`,
        `${rootPath}/nso-campaign-list`,
        `${rootPath}/maketoorder-list`,
        `${rootPath}/maketoorder-list-jewels`,
        `${rootPath}/feedback-list`,
        `${rootPath}/festive-feedback-list`,
        `${rootPath}/festive-ad-list`,
        `${rootPath}/liveassistance-list`,
        `${rootPath}/liveassistance-bookslot`,
        `${rootPath}/nps-list`,
        `${rootPath}/cta-list`,
    ],

    nach: [
        `${rootPath}/nach-list`,
        `${rootPath}/edit-nach`,
        `${rootPath}/add-nach`,
        `${rootPath}/managegold-price`,
    ],

    order: [`${rootPath}/search-order`, `${rootPath}/reset-password`],

    superadmin: [
        `${rootPath}/dashboard`,
        `${rootPath}/store-list`,
        `${rootPath}/add-store`,
        `${rootPath}/edit-store`,
        `${rootPath}/nach-list`,
        `${rootPath}/edit-nach`,
        `${rootPath}/add-nach`,
        `${rootPath}/search-order`,
        `${rootPath}/leadgeneration-list`,
        `${rootPath}/rannkaar-list`,
        `${rootPath}/prebook-list`,
        `${rootPath}/enquiry-list`,
        `${rootPath}/edit-prebook`,
        `${rootPath}/callback-list`,
        `${rootPath}/appointment-list`,
        `${rootPath}/store-master-list`,
        `${rootPath}/edit-store-master`,
        `${rootPath}/add-store-master`,
        `${rootPath}/managegold-price`,
        `${rootPath}/event-campaign-list`,
        `${rootPath}/users-list`,
        `${rootPath}/manage-user`,
        `${rootPath}/login-report`,
        `${rootPath}/nso-campaign-list`,
        `${rootPath}/maketoorder-list`,
        `${rootPath}/maketoorder-list-jewels`,
        `${rootPath}/feedback-list`,
        `${rootPath}/like-product-list`,
        `${rootPath}/wishlist`,
        `${rootPath}/manage-bar-code`,
        `${rootPath}/scan-bar-code`,
        `${rootPath}/upload-bar-code`,
        `${rootPath}/feedbacklist`,
        `${rootPath}/festive-feedback-list`,
        `${rootPath}/festive-ad-list`,
        `${rootPath}/liveassistance-list`,
        `${rootPath}/liveassistance-bookslot`,
        `${rootPath}/nps-list`,
        `${rootPath}/cta-list`,
    ],
};

/** -------------------------
 * AUTO LOGOUT TIME
 * ------------------------ */
export const AUTO_LOGOUT_TIMEOUT = 3600000; // 30 min

/** -------------------------
 * DATE / TIME
 * ------------------------ */
/* Dates are stored in UTC; show them in Indian Standard Time (UTC+05:30) with AM/PM,
   e.g. 2026-10-01, 03:30 PM. A missing or invalid date gives an empty string. */
export const formatIst = (value) => {
    const date = moment(value, moment.ISO_8601); // ISO only: no silent fallback to the browser's date parser
    return value && date.isValid() ? date.utcOffset('+05:30').format('YYYY-MM-DD, hh:mm A') : '';
};

/* The current time in Indian Standard Time, formatted for file names by default (e.g. 20261021_180542). */
export const formatIstNow = (format = 'YYYYMMDD_HHmmss') => moment().utcOffset('+05:30').format(format);

/* Number of days in a date range, counting both the first and the last day
   (2026/10/01 to 2026/10/07 is 7 days). Accepts "YYYY/MM/DD" (the range picker) and "YYYY-MM-DD".
   Returns 0 when either date is missing or invalid, or when the end is before the start. */
export const daysInRange = (startDate, endDate) => {
    const formats = ['YYYY/MM/DD', 'YYYY-MM-DD'];
    const start = moment(startDate, formats, true);
    const end = moment(endDate, formats, true);
    if (!start.isValid() || !end.isValid() || end.isBefore(start, 'day')) return 0;
    return end.diff(start, 'days') + 1;
};

/** -------------------------
 * LIST PAGING / SEARCH LIMITS (shared by the list screens)
 * ------------------------ */
/* The API returns at most this many rows per page (see getAllCampaignEvent in the backend).
   A shorter page means there is nothing left to load. */
export const PAGE_SIZE = 10000;

/* Longest date range that can be searched, counting the first and the last day (1 week) */
export const MAX_RANGE_DAYS = 7;

/* Distance from the bottom of the table (px) at which the next page is requested */
export const SCROLL_THRESHOLD = 50;
